import { ClassTypeOptions, ra, ra_property } from '@cundd/rest-adapter';
import { Department } from './Department';
import { SortableModelInterface } from './SortableModelInterface';

@ra(ClassTypeOptions.AddUnknownFields)
export class Industry implements SortableModelInterface {
    @ra_property()
    public name: string = '';

    @ra_property()
    public referenceId: string = '';

    @ra_property()
    public department?: Department;

    @ra_property()
    public sorting: number = 0;

    constructor(name: string, referenceId: string, department?
        : Department) {
        this.name = name;
        this.referenceId = referenceId;
        this.department = department;
    }
}
